var map = {
	"./assustado.png": 5982,
	"./falando.png": 8032,
	"./falando2.png": 3168,
	"./falando_feliz.png": 1709,
	"./falando_feliz2.png": 3883,
	"./feliz.png": 7315,
	"./normal.png": 1302,
	"./sorriso.png": 8946,
	"./sorriso2.png": 3978,
	"./triste.png": 4108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9734;